export default "__VITE_ASSET__BJrfc99m__"